import { createApp } from 'vue';
import storyRelationships from './components/StoryRelationships.vue';
import rateStory from './components/RateStory.vue';
import feedback from './components/Feedback.vue';
import comment from './components/Comment.vue';
import performers from './components/Performers.vue';

if(document.getElementById('story')) {
    const appStory = createApp();
    appStory.component('story-relationships', storyRelationships);
    appStory.component('rate-story', rateStory);
    appStory.component('feedback', feedback);
    appStory.component('comment', comment);
    appStory.component('performers', performers);
    appStory.mount('#story-view');
}

// if(document.getElementById('feedback-box')) {
//     new Vue({
//         el: '#feedback-box'
//     });
// }